import { isValidData } from './utils';

/**
 * Format a value with number formatting if it's numeric.
 * Skips formatting for year-related fields.
 */
const formatValue = (value, label = '') => {
  if (value == null || value === '') return value;
  // Skip number formatting for year-related labels
  if (label.toLowerCase().includes('year')) return value;
  const stripped = String(value).replace(/,/g, '').trim();
  const num = Number(stripped);
  if (!isNaN(num) && stripped !== '') {
    return num.toLocaleString('en-US');
  }
  return value;
};

/**
 * AmenitiesCard component for Commercial PDP.
 * Displays unit amenities, site amenities, property amenities (general), and industrial fields.
 */
const AmenitiesCard = ({
  unitAmenities,
  siteAmenities,
  propertyAmenities,
  subTypeFields = [],
}) => {
  const hasUnitAmenities = Array.isArray(unitAmenities) && unitAmenities.length > 0;
  const hasSiteAmenities = Array.isArray(siteAmenities) && siteAmenities.length > 0;
  const hasPropertyAmenities = Array.isArray(propertyAmenities) && propertyAmenities.length > 0;
  const hasSubTypeFields = Array.isArray(subTypeFields) && subTypeFields.length > 0;

  // Return null if all props are empty/null/undefined
  if (!hasUnitAmenities && !hasSiteAmenities && !hasPropertyAmenities && !hasSubTypeFields) {
    return null;
  }

  return (
    <div className="amenities-card">
      <h2 className="amenities-card__heading">Amenities</h2>

      {/* Unit Amenities */}
      {hasUnitAmenities && (
        <div className="amenities-card__section">
          <h3 className="amenities-card__sub-heading">Unit Amenities:</h3>
          <ul className="amenities-card__list">
            {unitAmenities.map((amenity, index) => (
              <li key={index} className="amenities-card__list-item">{amenity}</li>
            ))}
          </ul>
        </div>
      )}

      {/* Site Amenities */}
      {hasSiteAmenities && (
        <div className="amenities-card__section">
          <h3 className="amenities-card__sub-heading">Site Amenities:</h3>
          <ul className="amenities-card__list">
            {siteAmenities.map((amenity, index) => (
              <li key={index} className="amenities-card__list-item">{amenity}</li>
            ))}
          </ul>
        </div>
      )}

      {/* Property Amenities (Hospitality, Office, Retail, etc.) */}
      {hasPropertyAmenities && (
        <div className="amenities-card__section">
          <h3 className="amenities-card__sub-heading">Property Amenities:</h3>
          <ul className="amenities-card__list">
            {propertyAmenities.map((amenity, index) => (
              <li key={index} className="amenities-card__list-item">{amenity}</li>
            ))}
          </ul>
        </div>
      )}

      {/* Industrial fields */}
      {hasSubTypeFields && (
        <div className="amenities-card__metrics">
          {subTypeFields.map((field, index) => (
            <div key={index} className="amenities-card__metric-row">
              <span className="amenities-card__metric-label">{field.label}:</span>
              <span className="amenities-card__metric-value">{formatValue(field.value, field.label)}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default AmenitiesCard;
